import { round } from 'lodash';

export const toPercentage = (
  dividend: number,
  divisor: number,
  precision = 2,
) => {
  return divisor ? round((dividend / divisor) * 100, precision) : 0;
};
